import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconSavings } from '@redteclab/icons'

export const ProductVolumePricingModalNotification: FC = () => {
  return (
    <div className="flex flex-row gap-2 rounded-m bg-light-primary-low p-4">
      <span className="w-24">
        <div className="flex size-12 shrink-0 items-center justify-center rounded-full bg-light-tertiary font-mono text-2xl">
          <IconSavings />
        </div>
      </span>
      <div className="flex flex-col">
        <h3 className="mb-1 text-s font-medium text-dark-primary-max">
          <FormattedMessage id="volumePricing.modal.notification.title" />
        </h3>
        <span className="text-s font-normal">
          <FormattedMessage id="volumePricing.modal.notification.content" />
        </span>
      </div>
    </div>
  )
}
